import { HashRouter } from 'react-router-dom'
import AuthRoutes from './routes/authRoutes'
import PublicRoutes from './routes/publicRoutes'
import { useAuth } from './contexts/Auth'
import SidebarProvider from './contexts/SidebarContext'

function App() {
  const { usuario } = useAuth()
  const isDocsPath = window.location.pathname.startsWith("/site/")

  if (isDocsPath) return null
  
  return (
    
      <div className="App">
        <HashRouter>
          {usuario?.token ? (
            <SidebarProvider>
              <AuthRoutes />
            </SidebarProvider>
          ) : (
            <PublicRoutes />
          )}
        </HashRouter>
      </div>
  )
 }
 
 export default App
